// extracted by mini-css-extract-plugin
export default {"container":"ContainerFullHeight_container__Oor1+"};